import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import { ILoyaltyCert, ILoyaltyCertListItem } from '@/entity/loyalty/loyaltyCert/loyaltyCert/loyaltyCert.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { LoyaltyCertGeneralRequestType } from '@/form/loyalty/loyaltyCert/LoyaltyCertGeneral.types';
import { ResponseDataType } from '@/form/form.types';

import { prepareFormData } from '@/store/utils/formDataHelper';
import {IStoreReady} from "@/store/lib/storeSupport";
@Module({
    namespaced: true,
    name: 'loyaltyCert',
    store,
    dynamic: true,
})
class LoyaltyCertModule extends VuexModule implements  IStoreReady {
    loyaltyCerts: ILoyaltyCert | null = null;
    loyaltyCert: ILoyaltyCertListItem | null = null;
    loyaltyCertLoaded = false;
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ loyaltyCerts: ILoyaltyCert; loyaltyCertLoaded: boolean }> {
        console.log('LoyaltyCertModule fetchAll')
        let loyaltyCertLoaded = false;
        const loyaltyCerts = await store.$repository.loyaltyCert.fetchAll(prepareFormData(data));
        if (loyaltyCerts) {
            loyaltyCertLoaded = true;
        }
        return { loyaltyCerts, loyaltyCertLoaded };
    }

    @MutationAction
    async fetchData(
        data: PaginationRequestType
    ): Promise<{ loyaltyCert: ILoyaltyCertListItem; loyaltyCertLoaded: boolean }> {
        console.log('LoyaltyCertModule fetchData')
        let loyaltyCertLoaded = false;
        const loyaltyCert = await store.$repository.loyaltyCert.fetchData(data);
        if (loyaltyCert) {
            loyaltyCertLoaded = true;
        }
        return { loyaltyCert, loyaltyCertLoaded };
    }

    @Action({ rawError: true })
    async create(data: LoyaltyCertGeneralRequestType): Promise<ResponseDataType> {
        console.log('LoyaltyCertModule create')
        if (this.loyaltyCerts) {
            //this.loyaltyCerts.data.push(data as ILoyaltyCertListItem);
        }

        return await store.$repository.loyaltyCert.create(data);
    }
    @Action({ rawError: true })
    async update(data: LoyaltyCertGeneralRequestType): Promise<ResponseDataType> {
        console.log('LoyaltyCertModule update')
        return await store.$repository.loyaltyCert.update(data);
    }

    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        console.log('LoyaltyCertModule delete')
        const resp = await store.$repository.loyaltyCert.delete({id: id});
        return resp;
    }

    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
}

export const LoyaltyCertStore = getModule(LoyaltyCertModule);
